import React from 'react'
import { formatDate } from '../../utils/dateFormatter'
import { formatReadingTime } from '../../utils/readingTime'

interface PostMetaProps {
  author: string
  publishedAt: string
  readingTimeMin: number
  category: string
  updatedAt?: string
  showReadingTime?: boolean
}

export const PostMeta: React.FC<PostMetaProps> = ({
  author,
  publishedAt,
  readingTimeMin,
  category,
  updatedAt,
  showReadingTime = true,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '0 8px',
        fontSize: '0.8rem',
        color: 'var(--text-secondary)',
        fontFamily: "'JetBrains Mono', 'Courier New', monospace",
        alignItems: 'center',
      }}
    >
      <span>{author}</span>
      <span style={{ color: 'var(--border-color)' }}>·</span>
      <span>{formatDate(publishedAt)}</span>
      {showReadingTime && (
        <>
          <span style={{ color: 'var(--border-color)' }}>·</span>
          <span>{formatReadingTime(readingTimeMin)}</span>
        </>
      )}
      <span style={{ color: 'var(--border-color)' }}>·</span>
      <span style={{ color: 'var(--accent-cyan)' }}>{category}</span>
      {updatedAt && (
        <>
          <span style={{ color: 'var(--border-color)' }}>·</span>
          <span style={{ color: 'var(--text-muted, #555)', fontStyle: 'italic' }}>
            updated {formatDate(updatedAt)}
          </span>
        </>
      )}
    </div>
  )
}
